export function toGridRef(e, n, digits = 10) {
  // Clamp digits: even number between 2 and 10
  const p = Math.max(2, Math.min(10, (digits | 0) & ~1));

  if (!Number.isFinite(e) || !Number.isFinite(n)) return "";

  // Whole meters
  e = Math.round(e);
  n = Math.round(n);

  // Exclusive upper bounds (avoid 700000/1300000 edges)
  if (e < 0 || e >= 700000 || n < 0 || n >= 1300000) return "";

  const letters = "ABCDEFGHJKLMNOPQRSTUVWXYZ"; // (no I)
  const e100 = Math.floor(e / 100000);
  const n100 = Math.floor(n / 100000);

  // Derive 100km letter pair indices; bail if out of range
  const l1 = 19 - n100 - ((19 - n100) % 5) + Math.floor((e100 + 10) / 5);
  const l2 = ((19 - n100) % 5) * 5 + (e100 % 5);
  if (l1 < 0 || l1 >= letters.length || l2 < 0 || l2 >= letters.length)
    return "";

  const pair = letters[l1] + letters[l2];

  const scale = 10 ** (5 - p / 2);
  const eRem = Math.floor((e % 100000) / scale)
    .toString()
    .padStart(p / 2, "0");
  const nRem = Math.floor((n % 100000) / scale)
    .toString()
    .padStart(p / 2, "0");

  return `${pair} ${eRem} ${nRem}`;
}
